export enum DocumentsTool {
  visualizer = 'visualizer',
  tasks = 'tasks',
  reassignTasks = 'reassign-tasks',
  georeferencing = 'georeferencing',
}
